<template>
  <div
    v-if="modelValue"
    class="create_key_popup"
    @click.self="handleCancel"
    @touchmove.prevent
  >
    <div class="popup_panel">
      <div class="popup_title">创建新的API Key</div>

      <input
        v-model="keyName"
        class="name_input"
        type="text"
        maxlength="40"
        placeholder="请输入密钥名称"
      />

      <div class="popup_desc">用于标识不同用途的API Key，便于管理</div>

      <div class="popup_footer">
        <div class="footer_btn btn_cancel" @click="handleCancel">取消</div>
        <div class="footer_divider"></div>
        <div class="footer_btn btn_confirm" @click="handleConfirm">
          创建密钥
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "CreateApiKeyPopup",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "confirm"],
  setup(props, { emit }) {
    const keyName = ref("");

    watch(
      () => props.modelValue,
      (visible) => {
        if (visible) {
          keyName.value = "";
        }
      }
    );

    const handleCancel = () => {
      emit("update:modelValue", false);
    };

    const handleConfirm = () => {        
      emit("confirm", keyName.value.trim());
    };

    return {
      keyName,
      handleCancel,
      handleConfirm,
    };
  },
});
</script>

<style scoped lang="scss">
.create_key_popup {
  position: fixed;
  inset: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  //   padding: 0 0.28rem;
  box-sizing: border-box;

  .popup_panel {
    width: 100%;
    border-radius: 0.24rem;
    background: #fff;
    overflow: hidden;
    width: 6rem;
    height: 4.1rem;
  }

  .popup_title {
    margin-top: 0.42rem;
    font-size: 0.36rem;
    color: #333333;
    font-weight: 600;
    text-align: center;
  }

  .name_input {
    margin: 0.32rem auto 0;
    display: block;
    width: 5.36rem;
    height: 0.8rem;
    border: none;
    outline: none;
    border-radius: 0.12rem;
    background: #f5f5f7;
    color: #333;
    font-size: 0.3rem;
    padding: 0 0.2rem;
    box-sizing: border-box;

    &::placeholder {
      color: #b8b8b8;
    }
  }

  .popup_desc {
    margin: 0.2rem 0.32rem 0.34rem;
    color: #999;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }

  .popup_footer {
    position: relative;
    border-top: 1px solid #f0f0f0;
    height: 0.96rem;
    display: flex;
    align-items: center;

    .footer_divider {
      width: 1px;
      height: 0.38rem;
      background: #ededed;
    }

    .footer_btn {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.34rem;
    }

    .btn_cancel {
      color: #b3b3b3;
    }

    .btn_confirm {
      color: #ff5500;
      font-weight: 500;
    }
  }
}
</style>
